import React, { useState } from 'react';
import './BildeGalleri.css';

/**
 * Bildegalleri - Viser opplastede bilder med mulighet for sletting
 *
 * Props:
 * - bilder: Array av bilde-objekter
 * - onDelete: Callback når bilde slettes
 * - onRefresh: Callback for å refreshe bildeliste
 */
function BildeGalleri({ bilder = [], onDelete, onRefresh }) {
  const [sletter, setSletter] = useState({});
  const [visningsModusBilde, setVisningsModusBilde] = useState(null);

  if (!bilder || bilder.length === 0) {
    return (
      <div className="ingen-bilder">
        <p>Ingen bilder lastet opp ennå</p>
      </div>
    );
  }

  const handleSlett = async (bildeId) => {
    if (!window.confirm('Er du sikker på at du vil slette dette bildet?')) {
      return;
    }

    setSletter({ ...sletter, [bildeId]: true });

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'https://takstmann-api.swagner.workers.dev';

      // Hent token fra localStorage
      const token = localStorage.getItem('token');
      const headers = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_URL}/api/bilder/${bildeId}`, {
        method: 'DELETE',
        headers: headers
      });

      if (!response.ok) {
        throw new Error('Kunne ikke slette bilde');
      }

      // Callback
      if (onDelete) {
        onDelete(bildeId);
      }
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      console.error('Slett bilde error:', error);
      alert('Feil ved sletting av bilde: ' + error.message);
    } finally {
      setSletter({ ...sletter, [bildeId]: false });
    }
  };

  return (
    <div className="bilde-galleri">
      <div className="bilder-grid">
        {bilder.map((bilde) => (
          <div key={bilde.id} className="bilde-item">
            <div className="bilde-wrapper">
              <img
                src={bilde.cloudflare_r2_url}
                alt={bilde.filnavn}
                className="bilde-thumbnail"
                onClick={() => setVisningsModusBilde(bilde)}
              />
              <button
                className="slett-knapp"
                onClick={() => handleSlett(bilde.id)}
                disabled={sletter[bilde.id]}
                title="Slett bilde"
              >
                {sletter[bilde.id] ? '⏳' : '🗑️'}
              </button>
            </div>
            {bilde.bildetekst && (
              <p className="bildetekst">{bilde.bildetekst}</p>
            )}
            {bilde.beskrivelse && (
              <p className="bildebeskrivelse">{bilde.beskrivelse}</p>
            )}
            <p className="bilde-metadata">
              {bilde.filnavn} • {Math.round(bilde.filstorrelse / 1024)} KB
            </p>
          </div>
        ))}
      </div>

      {/* Fullscreen bilde-visning */}
      {visningsModusBilde && (
        <div className="bilde-modal" onClick={() => setVisningsModusBilde(null)}>
          <div className="bilde-modal-innhold">
            <button
              className="lukk-modal"
              onClick={() => setVisningsModusBilde(null)}
            >
              ✕
            </button>
            <img
              src={visningsModusBilde.cloudflare_r2_url}
              alt={visningsModusBilde.filnavn}
              className="bilde-fullscreen"
            />
            {visningsModusBilde.bildetekst && (
              <p className="modal-bildetekst">{visningsModusBilde.bildetekst}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default BildeGalleri;
